export default function MobileBottomBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/70">
      <div className="flex items-center justify-around h-14">
        <a
          href="tel:+494914238"
          className="flex flex-col items-center justify-center gap-0.5 px-4 py-2 text-foreground-600 hover:text-primary-600 transition-colors"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-lg"></i>
          <span className="text-[10px] font-medium">Anrufen</span>
        </a>
        <a
          href="/kontakt"
          className="flex flex-col items-center justify-center gap-0.5 px-4 py-2 text-foreground-600 hover:text-primary-600 transition-colors"
        >
          <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-lg"></i>
          <span className="text-[10px] font-medium">Anfahrt</span>
        </a>
      </div>
    </div>
  );
}